import React, { useState } from 'react';
import { FileSpreadsheet, FileText, Download, Eye, EyeOff } from 'lucide-react';
import { ReportArtifact, artifactUrl } from './artifacts';

const ArtifactCard: React.FC<{ artifact: ReportArtifact }> = ({ artifact }) => {
  const [showPdf, setShowPdf] = useState(false);
  const url = artifactUrl(artifact);
  const isPdf = artifact.kind === 'pdf';
  const Icon = isPdf ? FileText : FileSpreadsheet;

  return (
    <div className="mt-2 overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-dm-border dark:bg-dm-surface">
      {/* Antet */}
      <div className="flex items-center gap-2 border-b border-gray-100 px-3 py-2 dark:border-dm-border">
        <Icon size={18} className={isPdf ? 'text-red-500' : 'text-green-600'} />
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-medium text-gray-800 dark:text-dm-text">{artifact.title}</p>
          <p className="text-[11px] text-gray-400 dark:text-dm-text-muted">
            {artifact.kind.toUpperCase()} • {artifact.rowCount} {artifact.rowCount === 1 ? 'rând' : 'rânduri'}
            {artifact.hasMore && artifact.total ? ` (din ${artifact.total})` : ''}
          </p>
        </div>
        {isPdf && (
          <button
            onClick={() => setShowPdf((v) => !v)}
            title={showPdf ? 'Ascunde previzualizarea' : 'Previzualizează'}
            className="flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-medium text-gray-600 hover:bg-gray-100 dark:text-dm-text dark:hover:bg-dm-hover"
          >
            {showPdf ? <EyeOff size={13} /> : <Eye size={13} />}
            {showPdf ? 'Ascunde' : 'Vezi'}
          </button>
        )}
        <a
          href={url}
          download={artifact.filename}
          target="_blank"
          rel="noreferrer"
          title="Descarcă"
          className="flex items-center gap-1 rounded-md bg-primary px-2 py-1 text-[11px] font-medium text-black hover:opacity-90 dark:bg-dm-primary dark:text-white"
        >
          <Download size={13} /> Descarcă
        </a>
      </div>

      {/* Preview */}
      {isPdf ? (
        showPdf && <iframe title={artifact.title} src={url} className="h-72 w-full border-0" />
      ) : artifact.previewRows.length > 0 ? (
        <div className="max-h-60 overflow-auto">
          <table className="w-full border-collapse text-[11px]">
            <thead className="sticky top-0 bg-gray-50 dark:bg-dm-bg">
              <tr>
                {artifact.columns.map((c) => (
                  <th key={c.key} className="whitespace-nowrap border-b border-gray-200 px-2 py-1 text-left font-semibold text-gray-600 dark:border-dm-border dark:text-dm-text">
                    {c.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {artifact.previewRows.map((row, ri) => (
                <tr key={ri} className="even:bg-gray-50/50 dark:even:bg-dm-bg/40">
                  {row.map((cell, ci) => (
                    <td key={ci} className="whitespace-nowrap px-2 py-1 text-gray-700 dark:text-dm-text">
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          {artifact.rowCount > artifact.previewRows.length && (
            <p className="px-2 py-1 text-[10px] text-gray-400 dark:text-dm-text-muted">Previzualizare primele {artifact.previewRows.length} rânduri — descarcă pentru toate cele {artifact.rowCount}.</p>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default ArtifactCard;
